import { Component, OnInit, OnDestroy } from '@angular/core';
import { ToasterService, ToasterConfig } from 'angular2-toaster';
import { LoggerService } from './global-logger.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-logger',
  templateUrl: './logger.component.html'
})
export class LoggerComponent implements OnDestroy {

  infoMessageSubscription: Subscription;
  successMessageSubscription: Subscription;
  warningMessageSubscription: Subscription;
  errorMessageSubscription: Subscription;

  constructor(private toasterService: ToasterService, private loggerService: LoggerService) {
    this.infoMessageSubscription = this.loggerService.logInfoMessage$.subscribe(message => {
      this.toasterService.pop('info', message.message);
    });
    this.successMessageSubscription = this.loggerService.logSuccessMessage$.subscribe(message => {
      this.toasterService.pop('success', message.message);
    });
    this.warningMessageSubscription = this.loggerService.logWarningMessage$.subscribe(message => {
      this.toasterService.pop('warning', message.message);
    });
    this.errorMessageSubscription = this.loggerService.logErrorMessage$.subscribe(message => {
      this.toasterService.pop('error', message.message);
    });
  }

  public toasterconfig: ToasterConfig = new ToasterConfig({
    showCloseButton: false,
    tapToDismiss: true,
    timeout: 5000,
    positionClass: 'toast-bottom-center',
    animation: 'fade',
    mouseoverTimerStop: true,
    newestOnTop: true,
    iconClasses: {'hide': 'hide'}
  });

  ngOnDestroy() {
    this.infoMessageSubscription.unsubscribe();
    this.successMessageSubscription.unsubscribe();
    this.warningMessageSubscription.unsubscribe();
    this.errorMessageSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/core/logger/logger.component.ts